export const STEPS = ["Event type", "Guest count", "Purpose", "When & where", "Contact info"];
export const CURATING_LINES = ["Curating your special event…", "Matching the right games and hosts…", "Almost ready…"];

export const ORG_FIELD = {
  "Corporate Event": { label: "Company name", required: true, placeholder: "Your company" },
  "Country Club / Community": { label: "Country Club / Community name", required: true, placeholder: "Club or community name" },
  "Charity / Fundraiser": { label: "Organization / Charity name", required: true, placeholder: "Your organization" },
  "Private Celebration": { label: "Who's the celebration for?", required: false, placeholder: "e.g. Mom's 60th, the Smith wedding" },
  Other: { label: "Organization name (if any)", required: false, placeholder: "Optional" },
};

export const EVENT_TYPE_OPTIONS = [
  { value: "Corporate Event", emoji: "🏢", reaction: "Love it. Corporate crowds are our specialty — from leadership sessions to full conferences." },
  { value: "Private Celebration", emoji: "🎉", reaction: "Let's make it one they'll talk about for years." },
  { value: "Charity / Fundraiser", emoji: "💛", reaction: "Fun with a purpose — our favorite kind of night." },
  { value: "Country Club / Community", emoji: "🏌️", reaction: "Members and neighbors competing for bragging rights? Yes please." },
  { value: "Other", emoji: "✨", reaction: "Intriguing. We love a custom challenge." },
];

export const GUEST_OPTIONS = [
  { value: "Under 25", mid: 20, reaction: "Perfect size for an intimate, high-energy game." },
  { value: "25–50", mid: 38, reaction: "Awesome — a great size for everyone to get in on the action." },
  { value: "50–100", mid: 75, reaction: "Awesome — we've done small events all the way up to events with 1,000+ attendees." },
  { value: "100–250", mid: 175, reaction: "Awesome — we've done small events all the way up to events with 1,000+ attendees." },
  { value: "250–500", mid: 375, reaction: "Now we're talking. We've done events all the way up to 1,000+ attendees." },
  { value: "500–1,000", mid: 750, reaction: "A full room. We've hosted events with 1,000+ attendees, so you're in good hands." },
  { value: "1,000+", mid: 1000, reaction: "Big crowd? Bring it on — we've hosted events with 1,000+ attendees." },
];

export const PURPOSE_OPTIONS = {
  "Corporate Event": [
    { value: "Networking", reaction: "Nothing breaks the ice like a little friendly competition." },
    { value: "Team Building", reaction: "The best team building doesn't feel like team building. That's the whole idea." },
    { value: "Leadership Development", reaction: "Our game-based leadership sessions get people talking, deciding and collaborating — fast." },
    { value: "A Memorable Experience", reaction: "Memorable is our default setting." },
    { value: "All of the Above", all: ["Networking", "Team Building", "Leadership Development", "A Memorable Experience"], reaction: "Ambitious. We like that. We'll build a show that hits every one." },
  ],
  "Private Celebration": [
    { value: "Birthday", reaction: "Cake, candles and a championship trophy. Perfect." },
    { value: "Wedding", reaction: "Game show at a wedding? Instant legend status." },
    { value: "Anniversary", reaction: "Years of inside jokes make for the best trivia rounds." },
    { value: "Holiday", reaction: "Holiday cheer with a competitive streak. Count us in." },
    { value: "Other", text: true, reaction: "Tell us more — we love a good story." },
  ],
  "Charity / Fundraiser": [
    { value: "Fundraising Gala", reaction: "Sponsored rounds and prize moments are made for gala nights." },
    { value: "Donor Appreciation", reaction: "Show your donors a great time and they'll remember it." },
    { value: "Volunteer Celebration", reaction: "Your volunteers earned a night of fun. Let's deliver it." },
    { value: "Community Awareness", reaction: "A packed, laughing room is a great way to spread the word." },
    { value: "Other", text: true, reaction: "Tell us more — we love a good story." },
  ],
  "Country Club / Community": [
    { value: "Member Social", reaction: "Member socials are where friendly rivalries are born." },
    { value: "Holiday Event", reaction: "Holiday game nights fill the room every time." },
    { value: "Resident / HOA Gathering", reaction: "Neighbors versus neighbors. Bragging rights for a year." },
    { value: "Themed Game Night", reaction: "Pick the theme and we'll build the show around it." },
    { value: "Other", text: true, reaction: "Tell us more — we love a good story." },
  ],
};

export const REACTIONS = {
  when: "Got it — we'll check the calendar.",
  about: (first) => `Great, ${first}. Almost there.`,
  details: "Perfect. Every detail helps us build the right show.",
  otherPurpose: "A custom challenge — our favorite. Tell us what you have in mind.",
};
